import { Injectable } from "@angular/core";
import { characterMapping } from "../shared/nonlatincharsmapping";

@Injectable({
    providedIn: 'root'
})
export class LatinCharacterService{
    constructor(){}

    public characterMapping: { [key: string]: string } = characterMapping;

    public replaceNonLatinCharacters(inputText: string): string {
        if (!inputText) return inputText;
    
        const pattern = /[^\x00-\x7F]/g;
        return inputText.replace(pattern, (match) =>
          this.characterMapping[match] || match
        );
      }

} 